export default __webpack_public_path__ + "static/media/scary-js.0ff8c8b0.jpeg";